import { useMemo } from "react";

import makeUseCellCopyAction from "ds/components/Table/helpers/makeUseCellCopyAction";
import TableCellText from "ds/components/Table/Row/CellText";

import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const useCellCopyAction = makeUseCellCopyAction();

const NameCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  const copyAction = useCellCopyAction({ text: item.element.id });
  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <EnvironmentTableCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellText>{item.element.id}</TableCellText>
    </EnvironmentTableCell>
  );
};

export default NameCell;
